import ArrowRightIcon from '@/components/icons/arrow-right'
import { Link } from '@/navigation'
import { Game } from '@/types'
import blurHashToDataURL from '@/utils/blur-hash-to-data-url'
import { calculateEffectiveRTP } from '@/utils/game'
import Image from 'next/image'
import './game-card.scss'

export default function GameCard({ game }: { game: Game }) {
  const { name, path, rtp } = game
  // Check if thumbnail exists and provide defaults
  const thumbnail = game.thumbnail || { url: '/placeholder-game.webp', blurHash: '' }

  return (
    <Link
      href={path}
      className='game-card'
      style={{
        // Only try to use blurHash if it exists
        backgroundImage: thumbnail && thumbnail.blurHash
          ? `url(${blurHashToDataURL(thumbnail.blurHash, 10, 10)})`
          : undefined,
      }}
    >
      <Image
        src={thumbnail && thumbnail.url ? thumbnail.url : '/placeholder-game.webp'}
        alt={name || 'Game'}
        fill
        priority={false}
        loading='lazy'
      />
      {typeof rtp === 'number' ? (
        <div className='game-card__overlay'>
          <div className='game-card__info'>
            <span className='game-card__arrow'>
              <ArrowRightIcon />
            </span>
            <span className='game-card__title'>Effective RTP</span>
            <span className='game-card__rtp'>
              {calculateEffectiveRTP(rtp)}%
            </span>
          </div>
        </div>
      ) : null}
    </Link>
  )
}
